import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantityInput", "proposedAmountEur", "estimatedTransactionAmountEur", "estimatedTransactionRunningInterestsEur"]
  static values = {
    quantity: Number,
    amountPerUnit: Number,
    estimatedTransactionDate: String,
    estimatedTransactionRunningInterestsPerUnit: Number
  }

  connect() {
    this.quantityValue = JSON.parse(this.element.dataset.quantity) || 0
    this.amountPerUnitValue = parseFloat(JSON.parse(this.element.dataset.amountPerUnit)) || 0
    this.estimatedTransactionDateValue = JSON.parse(this.element.dataset.estimatedTransactionDate) || ""
    this.estimatedTransactionRunningInterestsPerUnitValue = parseFloat(JSON.parse(this.element.dataset.estimatedTransactionRunningInterestsPerUnit)) || 0
    this.handleQuantityInput()
  }

  handleQuantityInput() {
    this.quantityValue = parseInt(this.quantityInputTarget.value)
    this.proposedAmountEurTarget.textContent = this.proposedAmountEur().toFixed(2) + " €"
    this.estimatedTransactionAmountEurTarget.textContent = this.estimatedTransactionAmountEur().toFixed(2) + " €"
    this.estimatedTransactionRunningInterestsEurTarget.textContent = this.estimatedTransactionRunningInterestsEur().toFixed(2)
  }

  proposedAmountEur() {
    return Math.floor(this.quantityValue * this.amountPerUnitValue) / 100
  }
  estimatedTransactionRunningInterestsEur() {
    return Math.floor(this.quantityValue * this.estimatedTransactionRunningInterestsPerUnitValue) / 100
  }
  estimatedTransactionAmountEur() {
    return Math.floor(this.quantityValue * (this.amountPerUnitValue + this.estimatedTransactionRunningInterestsPerUnitValue)) / 100
  }
}